import CountriesList from "../Constants/CountriesList";
import CanStatesList from "../Constants/CANStatesList";
import UsStatesList from "../Constants/USStatesList";
import * as CountriesConstant from "../Constants/CountriesConstant";

export const isUsaCountry = (countryCode) => {
    return CountriesList.some((country) => country["alpha-3"] === CountriesConstant.UsaCode && (country["alpha-3"] === countryCode || country["alpha-2"] === countryCode));
}

export const isCanadianCountry = (countryCode) => {
    return CountriesList.some((country) => country["alpha-3"] === CountriesConstant.CanadaCode && (country["alpha-3"] === countryCode || country["alpha-2"] === countryCode));
}

export const isCanadianOrUsaCountry = (countryCode) => {
    return isCanadianCountry(countryCode) || isUsaCountry(countryCode);
}

export const getCountryName = (code) => {
    if (code) {
        let countryFound = CountriesList.find(country => {
            return country.name === code;
        });

        if (!countryFound) {
            if (code === "United States") {
                return "USA";
            }
        }

        return countryFound ? countryFound["alpha-3"] : code;
    } else {
        return "";
    }
};

export const getStateName = (code) => {
    if (code) {
        let stateFound = UsStatesList.find(state => {
            return state.name === code;
        });

        if (!stateFound) {
            stateFound = CanStatesList.find(state => {
                return state.name === code;
            });
        }

        return stateFound ? stateFound.abbreviation : code;
    } else {
        return "";
    }
};
